import { CommonPageALMeta } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { $PageLevelTraffic } from 'shared/atoms';
import { ArticleDetailUtil, EArticleClass } from 'shared/models';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $CurrentArticle } from '../shared/atoms/current-article';
import { useCompletedActiveSchema } from '~/utils/active/use-completed-active-schema';

export const ArticleFacebookALMeta = () => {
  const getSchemaOption: () => DeepLinkBuildingProps = () => {
    const currentArticle = useAtomValue($CurrentArticle);
    const schemaOption: DeepLinkBuildingProps = useMemo(() => {
      if (!ArticleDetailUtil.isArticleAvailable(currentArticle)) {
        return { pageType: 'feed', categoryId: 0 };
      }

      const { articleClass, groupId } = currentArticle;

      return { pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article', groupId };
    }, []);
    return schemaOption;
  };
  const schemaOption = getSchemaOption();

  const alMetaInfo = {
    openUrl: useCompletedActiveSchema(
      {
        ...schemaOption,
        pid: 'seo_al_fb',
      },
      {
        enterPosition: 'seo_al_fb',
      },
    ),
    webUrl: useAtomValue($PageLevelTraffic).canonicalUrl,
  };

  return <CommonPageALMeta {...alMetaInfo} />;
};
